var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwistedPair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 35,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANQAAABICAYAAACOetsgAAADCElEQVR4nO2dS27jQAxEW0GO4/ufRD6PB14QcIRobMdks8h+b5VFFjJVxWK3ftu+77cBAC58UUYAPzAUgCMYCsARDAXgyDbGcN+U2PedcwQluFwurof5veJp9y4i/J+VGmyIoR4FS1qBIlFNdZmEIpXysNqrNNdILXxH/MjHA77/TUrBENaC5zGF3Slx7AKZhVQ6lhVZSQvtt80xUz7HmmeN3zO0EGYohSJiJjBmaSE0oVQ6E+SzihbCR76sQpJOeqyghZZrKMwExmwtTDEUox8Y3bUwLaFmFZJ00qezFlqNfJgJjCwtTDUUox8YXbUwPaGiCkk61aOjFlqMfJgJjGwtpBjKszNhptp0G/3SEor1FBheWlBorqkj36eFJJ360EULZddQmAkMJS2kG4rRD4wOWpB5FfM7Xeb4v7cbb5PuxLZtP37NO1rInlTKjXyYCQzFsV/GUK/EPePgGhybZKXzLpVQ787QpFNfnplKdVOqzMjHqAemAeUdXjlD/ZZSjHprUrFpSibUs45DOq3Ds9FP7fpjuV0+zLQeZ+dc8WK+rKF+KxZmAnVKJdTxgh+AGrKGOtuIwFTrcXbOFTerJA3Frh4Y1RpoiZHvuJ4ipdZF/QZaOUOdbYtiqvU4u0lW2VRShuIZJzDeueNciVK7fKQUGKopJWOoV9MJU/Xn1XRSNJXEN3Y/HfWu16vzEUEW1cf+9IT6SwF5bB4MNS2UfUkLpurHX9NJSQuphvo03jFVH7poIc1QbJGD0UkL5d9tTkqBoaCFFEN5dyRMVZduWphuKEY9MDpqoc0XDEkpMDK1MNVQ0R0JU9WhqxamGYpRD4zOWmj10epBSsEDGVqYYqjZHQlT6dJdC+GGYtQDI0sLM00VaqhMM5FSWqzSWNutoR7BVGDM0kKYoVQ6EqbKZyUthDxgqB7vmCqP7mvo+7PG4e83VigiJtKguxbCDUU6gWIqlVtDDbbIQZi7NiP0GbKGUjYSJodItn3f+UYMgBOtr0MBzAZDATiCoQAcwVAAjmAoAC/GGP8AwoPgg1Oy8NsAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwistedPair);
export default __webpack_public_path__ + "static/media/TwistedPair.825319a03ee557d0e902e50fdefac03e.svg";
export { ForwardRef as ReactComponent };